<div class="container-fluid foot_logo_cls">
    <div class="row">

        <div class="col-md-12">
            <div class="logo_sec desk_logo_sec">
                <img src="assets/images/dgt all.png">
            </div>
            <!-- <img src="../assets/images/Skill India.png"  >
            <img src="../assets/images/iti1.png" >
            <img src="../assets/images/NIMI logo INV.png" >                       -->

            <div class="logo_sec mob_logo_sec">
                <img src="assets/images/DGET.png">
                <img src="assets/images/Skill India.png">
                <img src="assets/images/iti1.png">
                <img src="assets/images/NIMI logo INV.png">
            </div>

        </div>

    </div>
</div>

<!--footer Start-->
<footer>
    <div class="container-fluid">
        <div class="row footer_cls">

            <div class="col-md-3">
                <div class="contact_footer">
                    <h3>Contact Us </h3>
                    <h5>Hallticket Related Issues</h5>
                    <p>9AM to 5PM Only</p>
                    <ul>
                        <li><i class="fa fa-phone" aria-hidden="true"></i> 011-25847031</li>

                    </ul>
                </div>



            </div>




            <div class="col-md-3">
                <h3>DGT </h3>



                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d28012.219773311874!2d77.190945!3d28.643921!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1c57bb713f898c9c!2sDirectorate%20General%20of%20Training!5e0!3m2!1sen!2sin!4v1616760784409!5m2!1sen!2sin"
                    width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>


            </div>

            <div class="col-md-3">
                <h3>DGT Head Quarter</h3>




                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7003.556596329374!2d77.168096!3d28.636406000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4a46ec4dd6ed0c86!2sDGT%20Head%20Quarters%20(Directorate%20General%20of%20Training!5e0!3m2!1sen!2sin!4v1616760835823!5m2!1sen!2sin"
                    width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>


            </div>


            <div class="col-md-3">
                <h3>NIMI </h3>



                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7774.739595033338!2d80.214896!3d13.012107!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x384bc742d2c39e64!2sNational%20Instructional%20Media%20Institute(NIMI)!5e0!3m2!1sen!2sin!4v1616563808921!5m2!1sen!2sin"
                    width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>

            </div>



        </div>
    </div>
</footer>